<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="far fa-list-alt" aria-hidden="true"></i></span>{{ 'FacilityOptionMaintenance.Header' | translate }}
  </h1>

  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [(selected)]="isSearchFormOpen">

        <!-------------------------------------- Query Form ---------------------------------------------->
        <form [formGroup]="searchFormGroup" (ngSubmit)="searchBtnClick()">
          <div class="p-fluid formgrid grid">

            <!-------------------------------------- Facility Code slot ---------------------------------------------->
            <div class="field col-6">
              <label for="formFacilityCode">{{ 'FacilityOptionMaintenance.Form.FacilityCode' | translate }}</label>
              <input pInputText
                type="text"
                maxlength="100"
                id="formFacilityCode"
                formControlName="facilityCode"
              />
            </div>

            <!-------------------------------------- Option Type slot ---------------------------------------------->
            <div class="field col-6">
              <label for="formOptionType">{{ 'FacilityOptionMaintenance.Form.OptionType' | translate }}</label>
              <input pInputText
                type="text"
                maxlength="100"
                id="formOptionType"
                formControlName="optionType"
              />
            </div>

            <!-------------------------------------- Option Code slot ---------------------------------------------->
            <div class="field col-6">
              <label for="formOptionCode">{{ 'FacilityOptionMaintenance.Form.OptionCode' | translate }}</label>
              <input pInputText
                type="text"
                maxlength="100"
                id="formOptionCode"
                formControlName="optionCode"
              />
            </div>

            <!-------------------------------------- Is Activated slot ---------------------------------------------->
            <div class="field col-6">
              <label for="formIsActivated">{{ 'FacilityOptionMaintenance.Form.IsActivated' | translate }}</label>
              <p-dropdown
                inputId="formIsActivated"
                formControlName="isActivated"
                placeholder="{{ 'FacilityOptionMaintenance.Placeholder.OptionHint.SelectIsActivatedOrNot' | translate }}"
                [showClear]="true"
                [options]="isActivatedOptions"
              >
                <ng-template pTemplate="selectedItem" let-value>
                  {{ value.label | translate }}
                </ng-template>
                <ng-template pTemplate="item" let-item>
                  {{ item.label | translate }}
                </ng-template>
              </p-dropdown>
            </div>

          </div>

          <!-------------------------------------- Form Button ---------------------------------------------->
          <div>

            <!-------------------------------------- Query Button ---------------------------------------------->
            <button pButton
              type="submit"
              label="{{ 'Common.Button.Search' | translate }}"
            ></button>

            <!-------------------------------------- Reset Button ---------------------------------------------->
            <button pButton
              type="reset"
              label="{{ 'Common.Button.Reset' | translate }}"
              class="p-button-secondary ml-2"
            ></button>

          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <!-------------------------------------- Table ---------------------------------------------->
    <p-table
      #table
      laasDataTableSetting
      [tableKey]="preferenceKey"
      [defaultColumns]="selectedColumns"
      [columns]="selectedColumns"
      [value]="tableData"
      [loading]="isLoading"
      [resizableColumns]="true"
      [reorderableColumns]="true"

      [scrollable]="true"
      scrollHeight="500px"
      scrollDirection="both"

      [(selection)]="selectedRow"
      selectionMode="single"

      [lazy]="true"
      (onPage)="onTablePageChanging($event)"
      (onSort)="onTableSorting($event)"
      [resetPageOnSort]="false"

      [paginator]="true"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      [rows]="this.pageInfo.pageSize"
      [rowsPerPageOptions]="[5, 10, 20]"
      [totalRecords]="this.pageInfo.totalRecords"

      dataKey="dataKey"
      editMode="row"
      class="datatable"
      styleClass="p-datatable-gridlines p-datatable-stripped mt-2 white-space: nowrap;"
    >

      <!-------------------------------------- Table Caption Part ---------------------------------------------->
      <ng-template pTemplate="caption">

        <!-------------------------------------- Display Column List ---------------------------------------------->
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="table">
        </laas-table-column-toggle>

        <!-------------------------------------- Add Button ---------------------------------------------->
        <button pButton
          class="p-button-success p-button-raised ml-2"
          label="{{ 'Common.Button.Add' | translate }}"
          icon="fa fa-plus"
          [disabled]="!isInEditMode"
          (click)="addNewRow()"
        ></button>

        <!-------------------------------------- Delete Button ---------------------------------------------->
        <button pButton
          class="p-button-danger p-button-raised ml-2"
          label="{{ 'Common.Button.Delete' | translate }}"
          icon="fas fa-trash-alt"
          [disabled]="!isInEditMode || tableData.length <= 0"
          (click)="deleteSelectedRow()"
        ></button>

        <!-------------------------------------- Save Button ---------------------------------------------->
        <button pButton
          class="p-button-raised ml-2"
          label="{{ 'Common.Button.Save' | translate }}"
          icon="fas fa-save"
          [disabled]="!isInEditMode"
          (click)="saveChanges()"
        ></button>

        <!-------------------------------------- Restore Button ---------------------------------------------->
        <button pButton
          class="p-button-secondary p-button-raised ml-2"
          label="{{ 'FacilityOptionMaintenance.Table.Button.Restore' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!isInEditMode"
          (click)="restoreTableDate()"
        ></button>

        <!-------------------------------------- Edit Button ---------------------------------------------->
        <button pButton
          style="color: white"
          class="p-button-warning p-button-raised ml-2"
          label="{{ isInEditMode ? ( 'Common.Button.Cancel' | translate ) : ( 'Common.Button.Edit' | translate ) }}"
          icon="fas fa-pen"
          (click)="switchEditMode()"
        ></button>

      </ng-template>

      <!-------------------------------------- Table Column Group Part ---------------------------------------------->
      <!---------------------------- Make columns as a group for horizontal scroll ---------------------------------------------->
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" pReorderableColumn pResizableColumn
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            [attr.field]="col.field"
            scope="col"
          >
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <ng-container [ngSwitch]="col.field" *ngFor="let col of columns">

            <!-------------------------------------- SeqNo Column ---------------------------------------------->
            <td *ngSwitchCase="'seqNo'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: "-" }}
              </div>
            </td>

            <!-------------------------------------- Option Desc Column ---------------------------------------------->
            <td *ngSwitchCase="'optionDesc'">
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableOptionDesc"></label>
                  <input pInputText
                    type="text"
                    id="tableOptionDesc"
                    maxlength="255"
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Common Attr 02 Column ---------------------------------------------->
            <td *ngSwitchCase="'commonAttr02'">
              <p-cellEditor class="p-fluid">
                <label for="tableCommonAttr02"></label>
                <ng-template pTemplate="input">
                  <input pInputText
                    type="text"
                    id="tableCommonAttr02"
                    maxlength="1024"
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Is Activated Column ---------------------------------------------->
            <td *ngSwitchCase="'isActivated'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown
                    inputId="tablesActivated"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'FacilityOptionMaintenance.Placeholder.OptionHint.SelectIsActivatedOrNot' | translate }}"
                    [showClear]="true"
                    [options]="isActivatedOptions"
                    [(ngModel)]="rowData[col.field]"
                  >
                    <ng-template pTemplate="selectedItem" let-value>
                      {{ value.label | translate }}
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                      {{ item.label | translate }}
                    </ng-template>
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Create User Column ---------------------------------------------->
            <td *ngSwitchCase="'createUser'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- CreateDt Column ---------------------------------------------->
            <td *ngSwitchCase="'createDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- Update User Column ---------------------------------------------->
            <td *ngSwitchCase="'updateUser'">
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- UpdateDt Column ---------------------------------------------->
            <td *ngSwitchCase="'updateDt'">
              <div class="overflow-text">
                {{ rowData[col.field] | date: 'YYYY-MM-dd HH:mm:ss' | replaceNullWith: '-' }}
              </div>
            </td>

            <!-------------------------------------- Is Default Awb Address Column ---------------------------------------------->
            <td *ngSwitchCase="'isDefaultAwbAddress'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-dropdown
                    inputId="tableIsDefaultAwbAddress"
                    class="p-fluid"
                    appendTo="body"
                    placeholder="{{ 'FacilityOptionMaintenance.Placeholder.OptionHint.SelectIsDefaultAwbAddressOrNot' | translate }}"
                    [showClear]="true"
                    [options]="isDefaultAwbAddressOptions"
                    [(ngModel)]="rowData[col.field]"
                  >
                    <ng-template pTemplate="selectedItem" let-value>
                      {{ value.label | translate }}
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                      {{ item.label | translate }}
                    </ng-template>
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

            <!-------------------------------------- Default ---------------------------------------------->
            <td *ngSwitchDefault>
              <p-cellEditor class="p-fluid">
                <ng-template pTemplate="input">
                  <label for="tableDefault"></label>
                  <input pInputText
                    id="tableDefault"
                    type="text"
                    maxlength="100"
                    [(ngModel)]="rowData[col.field]"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{ rowData[col.field] | replaceNullWith: "-" }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>

          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{ 'Common.Table.NoData' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
